// removed by extract-text-webpack-plugin
module.exports = {"MacroLink":"MacroLink___2ZtN2","remove":"remove___3L4cd","handle":"handle___3FjjV","bars":"bars___1109E","notEditing":"notEditing___2aDVg","delete":"delete___ZVdDA","MacroLinkError":"MacroLinkError___3Lia_","notDraggable":"notDraggable___3WBQx"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/MacroLink/styles.scss
// module id = 342
// module chunks = 0